import { IonCard, IonCardTitle, IonCardContent, IonSegment, IonSegmentButton, IonLabel, IonCardHeader, IonContent, IonPage, IonButton } from "@ionic/react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { mk_ion_header } from "../functions/mk_ion_header";
import { useEffect, useState } from "react";
import { Preferences } from "@capacitor/preferences";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useIonRouter } from "@ionic/react";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { formatWoche } from "../functions/formatWoche";

export default function Speisekarte() {
  const {
    appToken,
    appSollReloadAuswahlChange,
    appSollReloadAuswahl,
    appServer,
    appStation,
    appStationBezeichnung,
    appBewohnerSollId,
    appBewohnerSollBezeichnung,
  } = useContext(DataContext);

  const [auswahl, setAuswahl] = useState<any>();
  const [segment, setSegment] = useState<any>("2");
  const [today, setToday] = useState<any>(new Date().toISOString().split("T")[0].replaceAll("-", ""));
  const [woche1, setWoche1] = useState<any>();
  const [woche2, setWoche2] = useState<any>();
  const [woche3, setWoche3] = useState<any>();
  const [woche4, setWoche4] = useState<any>();
  const [woche5, setWoche5] = useState<any>();
  const [woche6, setWoche6] = useState<any>();
  const [woche7, setWoche7] = useState<any>();

  const router = useIonRouter();

  function getData() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    myHeaders.append("Authorization", "Bearer " + appToken);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
    };
    fetch(appServer + "/funktionen/api2/senioren/auswahl.php?bewhohner_id=" + appBewohnerSollId, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        setAuswahl(JSON.stringify(result));

        let storagedata = {
          key: "senioren.auswahl",
          value: JSON.stringify(result),
        };

        await Preferences.set(storagedata);
      });
  }

  function mk_kachel_footer_bestellung( datumsql: string, zeit: string ) {
    let my_icon ;
    let my_component =
      <div className="flexbox-item" data-sf="mk_kachel_footer_bestellung">
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
            {auswahl &&
              JSON.parse(auswahl).map((elementInArray: any) => {
                if (elementInArray["bewohner_verzehr_zeit"] === zeit && elementInArray["bewohner_verzehr_tag"] === datumsql) {
                  my_icon = <CheckCircleIcon color="success" />;
                }
              })}
            { my_icon } Bestellung
          </AccordionSummary>
          {auswahl &&
            JSON.parse(auswahl).map((elementInArray: any) => {
              if (elementInArray["bewohner_verzehr_zeit"] === zeit && elementInArray["bewohner_verzehr_tag"] === datumsql) {
                return (
                  <AccordionDetails
                    key={
                      "key_" + elementInArray["bewohner_verzehr_tag"] + "_" + elementInArray["bewohner_verzehr_zeit"] + "_" + elementInArray["rezepte_id"]
                    }
                  >
                    {elementInArray["bewohner_verzehr_menge"]} x {elementInArray["rezepte_bezeichnung"]}
                  </AccordionDetails>
                );
              }
            })}
        </Accordion>
      </div>
    ;
    return my_component ;
  }

  function mk_kachel_mahlzeit(link_root: string , tag: string, datumsql: string, bg_img_url: string, bg_img_style: string, label: string ) {
    let my_component =
      <div
        className="flexbox-item"
        data-sf="mk_kachel_mahlzeit"
        onClick={() =>
          router.push(
            `${ link_root}/${ appStation }/${ appStationBezeichnung }/${ tag }/${ segment }/${ appBewohnerSollId }/${ appBewohnerSollBezeichnung }/${ datumsql }`
          )
        }
        style={{
          background: `url('${ bg_img_url }') ${ bg_img_style }`,
          backgroundSize: "cover",
        }}
      >
        <div className="overlay-container">
          <div className="overlay-item-bottom bg1">{ label }</div>
        </div>
      </div>
    ;
    return my_component ;
  }

  function mk_view_woche(tag: any) {
    let my_tag = formatDateSQL(today.toString(), tag ) ;
    return (
      <IonCard
        data-sf="mk_view_woche"
      >
        <IonCardHeader>
          <IonCardTitle>{today && formatDate(today.toString(), tag)}</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <div className={`flexbox-panel multiple`}>
            { mk_kachel_mahlzeit( '/mahlzeit/1' , tag, my_tag , '/assets/frueh.jpeg', 'no-repeat center center' , 'Frühstück' ) }
            { mk_kachel_mahlzeit( '/mittag' , tag, my_tag , '/assets/mittag.jpeg', 'no-repeat center center' , 'Mittag' ) }
            { mk_kachel_mahlzeit( '/mahlzeit/3' , tag, my_tag , '/assets/abend.jpeg', 'no-repeat' , 'Abendessen' ) }
          </div>

          <div className={`flexbox-panel`}>
            { mk_kachel_footer_bestellung( my_tag, '1' ) }
            { mk_kachel_footer_bestellung( my_tag, '2' ) }
            { mk_kachel_footer_bestellung( my_tag, '3' ) }
          </div>
        </IonCardContent>
      </IonCard>
    );
  }

  function formatDateSQL(string: any, tag: any) {
    let year = string.substr(0, 4);
    let month = string.substr(4, 2) - 1;
    let day = string.substr(6, 2);

    const date = new Date(year, month, day);
    let wochentag = date.getDay() - 1;

    date.setDate(date.getDate() + (segment * 7 - wochentag) + (tag - 1));
    date.getDate();

    let return_day = date.toLocaleDateString("en-GB", {
      day: "2-digit",
    });

    let return_month = date.toLocaleDateString("en-GB", {
      month: "2-digit",
    });

    let return_year = date.toLocaleDateString("en-GB", {
      year: "numeric",
    });

    return return_year + "-" + return_month + "-" + return_day;
  }

  function formatDate(string: any, tag: any) {
    let year = string.substr(0, 4);
    let month = string.substr(4, 2) - 1;
    let day = string.substr(6, 2);

    const date = new Date(year, month, day);
    let wochentag = date.getDay() - 1;

    date.setDate(date.getDate() + (segment * 7 - wochentag) + (tag - 1));
    date.getDate();

    return date.toLocaleDateString("de-DE", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "2-digit",
    });
  }

  useEffect(() => {
    // console.log( 'HUGGA' ) ;
    setToday(new Date().toISOString().split("T")[0].replaceAll("-", ""));
    setWoche1(mk_view_woche(1));
    setWoche2(mk_view_woche(2));
    setWoche3(mk_view_woche(3));
    setWoche4(mk_view_woche(4));
    setWoche5(mk_view_woche(5));
    setWoche6(mk_view_woche(6));
    setWoche7(mk_view_woche(7));
  }, [segment, auswahl]);

  useEffect(() => {
    // console.log( 'JUGGA' ) ;
    if (appServer !== undefined && appSollReloadAuswahl == true) {
      getData();
      appSollReloadAuswahlChange(false);
    }
  }, [appBewohnerSollId, appSollReloadAuswahl]);

  return (
    <IonPage>
      {mk_ion_header(`${appBewohnerSollBezeichnung} (${appStationBezeichnung})`)}
      <IonContent fullscreen>
        {mk_ion_header(`${appBewohnerSollBezeichnung} (${appStationBezeichnung})`, "large")}
        <IonButton routerLink={"/bewohner/" + appStation + "/" + appStationBezeichnung}>zurück</IonButton>

        <IonSegment
          value={segment}
          onClick={(e) => {
            let my_el: any = e;
            setSegment(my_el.target.value);
          }}
        >
          <IonSegmentButton value="0">
            <IonLabel>{formatWoche(0)}</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="1">
            <IonLabel>{formatWoche(1)}</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="2">
            <IonLabel>{formatWoche(2)}</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="3">
            <IonLabel>{formatWoche(3)}</IonLabel>
          </IonSegmentButton>
        </IonSegment>

        {woche1}
        {woche2}
        {woche3}
        {woche4}
        {woche5}
        {woche6}
        {woche7}
      </IonContent>
    </IonPage>
  );
}
